import { useState, useRef } from "react";

function useDirtyState(initialValue) {
  const [value, setValue] = useState(initialValue);

  const initialRef = useRef(initialValue);
  const dirtyRef = useRef(false);

  function update(newValue) {
    setValue(newValue);

    const changed =
      JSON.stringify(newValue) !== JSON.stringify(initialRef.current);

    dirtyRef.current = changed;
  }

  function resetDirty() {
    initialRef.current = value;
    dirtyRef.current = false;
  }

  function resetValue() {
    setValue(initialRef.current);
    dirtyRef.current = false;
    return initialRef.current;
  }

  function hasChanges() {
    return dirtyRef.current;
  }

  function getValue() {
    return value;
  }

  return {
    value,
    update,
    hasChanges,
    resetDirty,
    resetValue,
    getValue,
  };
}

export default useDirtyState;
